import { Coord } from '../../../jscaip/Coord';
import { PlayerNumberMap } from '../../../jscaip/PlayerMap';
import { PlayerOrNoneGameStateWithTable } from '../../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class ReversiState extends PlayerOrNoneGameStateWithTable {
    getNeighboringPawnLike(searchedValue, center) {
        let coord;
        const result = [];
        for (let ny = -1; ny < 2; ny++) {
            for (let nx = -1; nx < 2; nx++) {
                coord = new Coord(center.x + nx, center.y + ny);
                if (this.isOnBoard(coord)) {
                    if (this.board[coord.y][coord.x] === searchedValue) {
                        result.push(coord);
                    }
                }
            }
        }
        return result;
    }
    countScore() {
        const scores = PlayerNumberMap.of(0, 0);
        for (const coordAndContent of this.getPlayerCoordsAndContent()) {
            const spaceOwner = coordAndContent.content;
            scores.add(spaceOwner, 1);
        }
        return scores;
    }
}
